const OrgRoleKeys = {
  all: ['OrgRoles'] as const,
  lists: () => [...OrgRoleKeys.all, 'list'] as const,
  list: (queryParams: string) => [...OrgRoleKeys.lists(), { queryParams }] as const,
  details: () => [...OrgRoleKeys.all, 'detail'] as const,
  detail: (id: string) => [...OrgRoleKeys.details(), id] as const,
  byUsers: () => [...OrgRoleKeys.all, 'byUser'] as const,
  byUser: (id: string) => [...OrgRoleKeys.byUsers(), id] as const,
};

export { OrgRoleKeys };
